<style lang="less" scoped>
  @import '../../styles/global.less';

  .content {
    padding: 29px 40px;
  }

  .form-group {
    width: calc(100%);
  }

  .form-content {
    position: relative;
    display: flex;
    flex-flow:row wrap;
    top: -12px;
    margin: 0 -20px;
  }

  .form-box {
    &.type-1 { flex: 1; min-width: 250px; }
    &.type-2 { flex: 2; min-width: 500px; }
    position: relative;
    border-radius: 5px;
    float: left;
    min-height: 337px;
    margin: 20px;
    border: 1px solid #e3e3e3;

    h3 {
      position: relative;
      z-index: 1;
      font-size: 15px;
      color: #ff6c00;
      border-bottom: 1px solid #e3e3e3;
      background-color: #fff;
      border-radius: 5px 5px 0 0;
      line-height: 50px;
      text-indent: 20px;
      span {
        .abs-tcenter;
        font-size: 13px;
        font-weight: normal;
        color: #808080;
        right: 20px;
      }
      button {
        .abs-tcenter;
        right: 8px;
        padding-left: 15px;
        padding-right: 15px;
      }
    }
    .img {
      .abs-center;
      width: 100%; height: 100%;
      background-color: #f5f9fc;
      img {
        .abs-center;
        margin-top: 23px;
        border: 1px solid #e3e3e3;
        background-size: contain;
        background-repeat: no-repeat;
        background-position: center;
        background-color: #fff;
      }
    }
    form {
      padding: 22px 40px 0 20px;
      input[type=file] {
        position: absolute;
        z-index: 1;
        width: 100%;
        left: 0;
        top: 51px;
        bottom: 0;
        opacity: 0;
      }
    }

    p.cmt {
      text-align: center;
      font-size: 13px;
      padding: 25px 0 45px;
      em {
        font-style: normal;
        color: #7965ef;
      }
    }
  }
</style>

<style lang="less">
  .abs-lcenter { position: absolute; left: 50%; transform: translate(-50%,0); }

  .el-input-group__prepend{
    width: 100px;
    background-color: #fff;
  }
  .el-upload {
    position: absolute;
    left: 0;
    top: 51px;
    right: 0;
    bottom: 0;
    z-index: 1;
    button {
      opacity: 0;
    }
  }
</style>


<template lang="pug">
  section.content
    .title-content
      h2 정보수정

    .form-content
      .form-box.type-2
        h3 로그인 정보
          el-button(size="medium", :type="loginInfo.modifyBtn", :loading="loginInfo.login", @click="modifyPassword") {{ loginInfo.btnText }}
        el-form(
          id="passwordFrm",
          :model="loginInfo",
          :rules="rules",
          label-width="120px",
          label-position="left",
          :disabled="loginInfo.frmDisabled",
          ref="formRef",
        )
          el-form-item(label="아이디")
            .form-group
              el-input.md(v-model="me.id" disabled)
          el-form-item(label="현재 비밀번호", prop="oldPasswd")
            .form-group
              el-input.md(type="password", v-model="loginInfo.oldPasswd")
          el-form-item(label="새 비밀번호", prop="passwd")
            .form-group
              el-input.md(type="password", v-model="loginInfo.passwd")
          el-form-item(label="새 비밀번호 확인", prop="passwdValidator")
            .form-group
              el-input.md(type="password", v-model="loginInfo.passwdValidator")

      .form-box.type-2
        h3 담당자 정보
          el-button(size="medium", :type="managerInfo.modifyBtn", :loading="managerInfo.login", @click="modifyManager") {{ managerInfo.btnText }}
        el-form(
          id="infoFrm",
          :model="managerInfo",
          :rules="rules",
          label-width="120px",
          label-position="left",
          :disabled="managerInfo.frmDisabled",
          ref="formRef2",
        )
          el-form-item.is-no-asterisk(label="이름", prop="contactName")
            .form-group
              el-input.md(v-model="managerInfo.contactName")

          el-form-item.is-no-asterisk(label="직급 / 직책", prop="contactDuty")
            .form-group
              el-input.md(v-model="managerInfo.contactDuty")

          el-form-item.is-no-asterisk(label="이메일", prop="contactEmail")
            .form-group
              el-input.md(v-model="managerInfo.contactEmail")

          el-form-item.is-no-asterisk(label="유선전화", prop="contactPhone")
            .form-group
              el-input.md(v-model="managerInfo.contactPhone")
                el-select(slot="prepend" v-model="telPrefix")
                  el-option(label="02", value="02")
                  el-option(label="031", value="031")
                  el-option(label="032", value="032")
                  el-option(label="033", value="033")
                  el-option(label="041", value="041")
                  el-option(label="042", value="042")
                  el-option(label="043", value="043")
                  el-option(label="051", value="051")
                  el-option(label="052", value="052")
                  el-option(label="053", value="053")
                  el-option(label="054", value="054")
                  el-option(label="055", value="055")
                  el-option(label="061", value="061")
                  el-option(label="062", value="062")
                  el-option(label="063", value="063")
                  el-option(label="064", value="064")
                  el-option(label="070", value="070")
                  el-option(label="030", value="030")
                  el-option(label="050", value="050")
                  el-option(label="060", value="060")
                  el-option(label="080", value="080")
                  el-option(label="0502", value="0502")
                  el-option(label="0503", value="0503")
                  el-option(label="0504", value="0504")
                  el-option(label="0505", value="0505")
                  el-option(label="0507", value="0507")
                  el-option(label="010", value="010")
                  el-option(label="011", value="011")
                  el-option(label="016", value="016")
                  el-option(label="017", value="017")
                  el-option(label="018", value="018")
                  el-option(label="019", value="019")
          el-form-item.is-no-asterisk(label="휴대전화", prop="contactMobile")
            .form-group
              el-input.md(v-model="managerInfo.contactMobile")
                el-select(slot="prepend" v-model="phoneNumberPrefix")
                  el-option(label="010", value="010")
                  el-option(label="011", value="011")
                  el-option(label="016", value="016")
                  el-option(label="017", value="017")
                  el-option(label="018", value="018")
                  el-option(label="019", value="019")

      .form-box.type-1
        h3 사업자 등록증
          el-button(size="medium", :type="docInfo.modifyBtn", :loading="docInfo.login", @click="modifyDoc") {{ docInfo.btnText }}
        el-form(
          id="docFrm",
          :model="docInfo",
          :rules="rules",
          :disabled="docInfo.frmDisabled"
        )
          input(type="file", @change="uploadDoc", accept="image/*", :disabled="docInfo.frmDisabled")
          .img
            img(
              width="146",
              height="202",
              class="abs-center",
              :style="{ backgroundImage: `url('${docInfo.file}')` }",
            )

      .form-box.type-2
        h3 쇼핑몰 기본 정보
          span 수정 불가
        el-form(label-width="120px", label-position="left", disabled)
          el-form-item(label="쇼핑몰 명")
            .form-group
              el-input.md(v-model="form.storeName")

          el-form-item(label="웹 도메인")
            .form-group
              el-input.md(v-model="form.storeDomain")

          el-form-item(label="모바일 도메인")
            .form-group
              el-input.md(v-model="form.storeMobDomain")

          el-form-item(label="호스팅사")
            .form-group
              el-input.md(v-model="form.hostingCode")
        p.cmt 쇼핑몰 기본 정보 수정은 <em>고객센터 02-3442-3555</em>로 문의

      .form-box.type-2
        h3 쇼핑몰 속성
          span 수정 불가
        el-form(label-width="120px", label-position="left", disabled)
          el-form-item(label="성별")
            .form-group
              el-input.md(v-model="form.storeGender == 'F'?'여성':form.storeGender == 'A'?'혼성':'남성'")

          el-form-item(label="소호 / 브랜드")
            .form-group
              el-input.md(v-model="form.storeType == 'S'?'소호몰':'브랜드몰'")

          el-form-item(label="연령대")
            .form-group
              el-input.md(v-model="form.ageNames")

          el-form-item(label="카테고리")
            .form-group
              el-input.md(v-model="form.cateNames")
        p.cmt 쇼핑몰 기본 정보 수정은 <em>고객센터 02-3442-3555</em>로 문의

</template>

<script>
import { mapState } from 'vuex';

export default {
  computed: {
    ...mapState({
      me: state => state.me,
    }),
  },
  async mounted() {
    const info = await this.$http.get('/api/mkc/v1/current-store');
    this.managerInfo.contactName = info.data.data.contactName;
    this.managerInfo.contactDuty = info.data.data.contactDuty;
    this.managerInfo.contactEmail = info.data.data.contactEmail;

    const [tel] = info.data.data.contactPhone.split('-');
    this.telPrefix = tel;
    const [phone] = info.data.data.contactMobile.split('-');
    this.phoneNumberPrefix = phone;

    this.managerInfo.contactPhone = info.data.data.contactPhone.replace(`${tel}-`, '');
    this.managerInfo.contactMobile = info.data.data.contactMobile.replace(`${phone}-`, '');

    this.docInfo.file = `${this.s3ProdImgPath}${info.data.data.licensePath}`;

    this.form.storeName = info.data.data.storeName;
    this.form.storeDomain = info.data.data.storeDomain;
    this.form.storeMobDomain = info.data.data.storeMobDomain;
    this.form.hostingCode = info.data.data.hostingCode;

    this.form.storeGender = info.data.data.storeGender;
    this.form.storeType = info.data.data.storeType;
    this.form.ageNames = info.data.data.ageNames;
    this.form.cateNames = info.data.data.cateNames;
  },
  methods: {
    // 비밀번호 변경
    async modifyPassword() {
      if (this.loginInfo.frmDisabled) {
        // 수정
        this.loginInfo.btnText = '완료';
        this.loginInfo.frmDisabled = false;
        this.loginInfo.modifyBtn = 'primary';
      } else {
        // 완료
        this.loginInfo.loading = true;
        this.loginInfo.frmDisabled = true;

        const valid = await this.$refs.formRef.validate();
        if (!valid) {
          this.$message('입력값을 확인해주세요');
          return;
        }

        const formdata = new FormData();
        formdata.append('old-passwd', this.loginInfo.oldPasswd);
        formdata.append('new-passwd', this.loginInfo.passwd);
        formdata.append('re-passwd', this.loginInfo.passwdValidator);

        try {
          await this.$http.post('/api/mkc/v1/company-user-passwd', formdata);
          setTimeout(() => {
            this.loginInfo.loading = false;
            this.loginInfo.btnText = '수정';
            this.loginInfo.modifyBtn = 'warning';

            this.loginInfo.oldPasswd = '';
            this.loginInfo.passwd = '';
            this.loginInfo.passwdValidator = '';
          }, 1000);
        } catch (e) {
          this.loginInfo.loading = false;
          this.loginInfo.frmDisabled = false;
          this.$alert(e.response.data.message, {
            confirmButtonText: '확인',
          });
        }
      }
    },

    // 담당자 정보 변경
    async modifyManager() {
      if (this.managerInfo.frmDisabled) {
        // 수정
        this.managerInfo.btnText = '완료';
        this.managerInfo.frmDisabled = false;
        this.managerInfo.modifyBtn = 'primary';

        this.managerInfo.contactPhone = this.managerInfo.contactPhone.replace(/-/g, '');
        this.managerInfo.contactMobile = this.managerInfo.contactMobile.replace(/-/g, '');
      } else {
        // 완료
        this.managerInfo.loading = true;
        this.managerInfo.frmDisabled = true;

        const valid = await this.$refs.formRef2.validate();
        if (!valid) {
          this.managerInfo.loading = false;
          this.managerInfo.frmDisabled = false;
          this.$message('입력값을 확인해주세요');
          return;
        }

        this.managerInfo.contactPhone = this.managerInfo.contactPhone.replace(/([0-9]+)([0-9]{4})/, '$1-$2');
        this.managerInfo.contactMobile = this.managerInfo.contactMobile.replace(/([0-9]+)([0-9]{4})/, '$1-$2');

        const formdata = new FormData();
        formdata.append('contactName', this.managerInfo.contactName);
        formdata.append('contactDuty', this.managerInfo.contactDuty);
        formdata.append('contactEmail', this.managerInfo.contactEmail);
        formdata.append('contactPhone', `${this.telPrefix}-${this.managerInfo.contactPhone}`);
        formdata.append('contactMobile', `${this.telPrefix}-${this.managerInfo.contactMobile}`);

        try {
          await this.$http.post('/api/mkc/v1/contact-info', formdata);
          setTimeout(() => {
            this.managerInfo.loading = false;
            this.managerInfo.btnText = '수정';
            this.managerInfo.modifyBtn = 'warning';

            this.managerInfo.oldPasswd = '';
            this.managerInfo.passwd = '';
            this.managerInfo.passwdValidator = '';
          }, 1000);
        } catch (e) {
          this.managerInfo.loading = false;
          this.managerInfo.frmDisabled = false;
          this.$alert(e.response.data.message, {
            confirmButtonText: '확인',
          });
        }
      }
    },

    // 사업자등록증 변경
    async modifyDoc() {
      if (this.docInfo.frmDisabled) {
        // 수정
        this.docInfo.btnText = '완료';
        this.docInfo.frmDisabled = false;
        this.docInfo.modifyBtn = 'primary';
      } else {
        // 완료
        this.docInfo.loading = true;
        this.docInfo.frmDisabled = true;

        if (this.docInfo.newFile === null) {
          this.docInfo.loading = false;
          this.docInfo.frmDisabled = false;
          this.$alert('사업자등록증을 첨부해 주세요.', {
            confirmButtonText: '확인',
          });
          return;
        }

        const formdata = new FormData();
        formdata.append('licenseFile', this.docInfo.newFile);

        try {
          await this.$http.post('/api/mkc/v1/license-file', formdata);
          setTimeout(() => {
            this.docInfo.loading = false;
            this.docInfo.btnText = '수정';
            this.docInfo.modifyBtn = 'warning';

            this.docInfo.newFile = null;
          }, 1000);
        } catch (e) {
          this.docInfo.loading = false;
          this.docInfo.frmDisabled = false;
          this.$alert(e.response.data.message, {
            confirmButtonText: '확인',
          });
        }
      }
    },
    uploadDoc(e) {
      const file = e.target.files[0];
      if (!file) return;
      const reader = new FileReader();
      const formdata = new FormData();
      this.docInfo.newFile = file;

      formdata.append('file', file);
      reader.addEventListener('load', () => {
        this.docInfo.file = reader.result;
      }, false);

      if (file) reader.readAsDataURL(file);
    },
    handlePreview(file) {
      console.log(file.url);
    },
  },
  data() {
    // 비밀번호 체크
    const validateOldPasswd = (rule, value, callback) => {
      console.log(value);
      if (value === '') {
        callback(new Error('이전 비밀번호를 다시 입력하세요.'));
      }
      callback();
    };
    const validatePasswd = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('비밀번호를 다시 입력하세요.'));
      } else if (this.loginInfo.passwdValidator !== '') {
        this.$refs.formRef.validateField('passwdValidator');
      }
      callback();
    };
    const validatePasswdValidator = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('비밀번호확인을 다시 입력하세요.'));
      } else if (value !== this.loginInfo.passwd) {
        callback(new Error('비밀번호 확인과 다릅니다.'));
      }
      callback();
    };

    return {
      loginInfo: {
        loading: false,
        btnText: '수정',
        modifyBtn: 'warning',
        frmDisabled: true,
        username: null,
        oldPasswd: '',
        passwd: '',
        passwdValidator: '',
      },
      managerInfo: {
        loading: false,
        btnText: '수정',
        modifyBtn: 'warning',
        frmDisabled: true,
        contactName: '',
        contactDuty: '',
        contactEmail: '',
        contactPhone: '',
        contactMobile: '',
      },
      docInfo: {
        loading: false,
        btnText: '수정',
        modifyBtn: 'warning',
        frmDisabled: true,
        file: 'https://s3.ap-northeast-2.amazonaws.com/sta1-upload-local/_up/com/lic/2019/1547717534059.png',
        newFile: null,
      },
      form: {
        passwordFrmDisabled: true,
        storeName: '',
        storeDomain: '',
        storeMobDomain: '',
        hostingCode: '',
        storeGender: '',
        storeType: '',
        ageNames: '',
        cateNames: '',

        licenseType: 'file', // 'file', 'fax'
        businessLicense: null,
      },
      isUsernameDuplicated: true,
      telPrefix: '02',
      phoneNumberPrefix: '010',

      rules: {
        oldPasswd: [
          { validator: validateOldPasswd, trigger: 'blur' },
        ],
        passwd: [
          { validator: validatePasswd, trigger: 'blur' },
        ],
        passwdValidator: [
          { validator: validatePasswdValidator, trigger: 'blur' },
        ],

        contactName: [
          { required: true, message: '담당자명을 입력해 주세요.', trigger: 'blur' },
        ],
        contactDuty: [
          { required: true, message: '담당자 직급/직책을 입력해 주세요.', trigger: 'blur' },
        ],
        contactEmail: [
          { required: true, message: '담당자 이메일을 입력해 주세요.', trigger: 'blur' },
        ],
        contactPhone: [
          { required: true, message: '담당자 유선전화를 입력해 주세요.', trigger: 'blur' },
        ],
        contactMobile: [
          { required: true, message: '담당자 휴대전화를 입력해 주세요.', trigger: 'blur' },
        ],
      },
    };
  },
};
</script>
